export type PixePhotoPreviewSource = {
  previewUrl: string
  imageUrl?: string
  thumbUrl512?: string
}

export function getPixePhotoPreviewUrl(photo: PixePhotoPreviewSource, fallbackToImage: boolean): string {
  if (!fallbackToImage && photo.thumbUrl512) return photo.thumbUrl512
  if (photo.imageUrl) return photo.imageUrl
  return photo.previewUrl || ''
}
